<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Profile from "@/components/widgets/profile";
import Earning from "@/components/widgets/earning";
import Stat from "@/components/widgets/stat";
import Emailsent from "@/components/widgets/emailsent";
import ProcurementSummary from "@/components/widgets/procurement-summary";

let newTrack = window.AGENCY_NAME && window.AGENCY_NAME.toLowerCase() !== "ustp";
/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Dashboard",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Profile,
    Earning,
    DocumentTracking: () => newTrack ? import("@/components/widgets/document-tracking(new)") : import("@/components/widgets/document-tracking"),
    Stat,
    Emailsent,
    ProcurementSummary,
  },
  data() {
    return {
      title: "Dashboard",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Dashboards",
          active: true,
        },
      ],
      fetchingStats: true,
      earningStatus: true,
      statData: [
        {
          icon: "bx bx-copy-alt",
          title: "Orders",
          value: "1,235",
        },
        {
          icon: "bx bx-archive-in",
          title: "Revenue",
          value: "$35, 723",
        },
        {
          icon: "bx bx-purchase-tag-alt",
          title: "Average Price",
          value: "$16.2",
        },
      ],
      userProfile: {
        firstName: "",
        lastName: "",
      },
      dashboardData: null,
      fundSources: [],
      selectedFSId: null,
      managePR: false,
      accessList: localStorage.getItem("userAccess") ? this.$store.state.decrypt.userAccessList() : []
    };
  },
  async mounted() {
    this.getUser();
    if (this.$store.state.data.selectedDU) {
      await this.getMenuCounts(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id, this.$store.state.data.selectedDU.id);
    }
    if (this.$store.state.decrypt.isAdmin()) {
      this.managePR = true;
    } else {
      let accessList = this.$store.state.decrypt.userAccessList();
      let access = accessList.find(
        (x) =>
          x.Access.toLowerCase() === "manage pr" &&
          x.Type.toLowerCase() === "procurement"
      );
      if (access) {
        this.managePR = true;
      } else {
        this.managePR = false;
      }
    }
    if (this.managePR) {
      await this.getFundSources(this.$store.state.data.selectedCampus.id);
      if (this.selectedFSId) {
        this.getProcurementSummary(this.selectedFSId, this.$store.state.data.cycle);
        this.getProcurementItemRequest(this.$store.state.data.selectedCampus.id);
      }
    }
  },
  methods: {
    async getFundSources(id) {
      await this.$store
        .dispatch("fundsource/GetFundSourcesByCampusId", id)
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          this.fundSources = res.data;
          if(res.data.length == 0) return;
          this.selectedFSId = this.fundSources[0].id;
          this.$refs.psRef.fundSourceId = this.selectedFSId;
        })
        .catch((err) => {
          console.log(err)
          return this.showToast(
            "Something went wrong! - Getting Fund Sources",
            "error"
          );
        });
    },
    async getProcurementSummary(fsId, cycle) {
      await this.$store
        .dispatch("dashboard/GetProcurementSummary", { fsId, cycle })
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          this.$refs.psRef.setData(res.data);
        })
        .catch((err) => {
          // return this.showToast(
          //   "Something went wrong! - Getting Summary",
          //   "error"
          // );
        });
    },
    getUser() {
      this.$store
        .dispatch("account/GetProfile")
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          this.userProfile = res.data;
        })
        .catch((err) => {
          return this.showToast(
            "Something went wrong! - Getting User Profile",
            "error"
          );
        });
    },
    async changeCycle(cycle) {
      await this.getMenuCounts(cycle, this.$store.state.data.selectedCampus.id, this.$store.state.data.selectedDU.id);
      if (this.selectedFSId && this.managePR) {
        this.getProcurementSummary(this.selectedFSId, cycle);
      }
    },
    async changeDU(du) {
      if (du) {
        await this.getMenuCounts(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id, du.id);
      }
    },
    async changeCampus(campusId) {
      if (this.managePR) {
        await this.getFundSources(campusId);
        if (this.selectedFSId) {
          this.getProcurementSummary(
            this.selectedFSId,
            this.$store.state.data.cycle
          );
          this.getProcurementItemRequest(campusId);
        }
      }
    },
    async getMenuCounts(cycle, campusId, deliveryUnitId) {
      if (localStorage.getItem('dashboardData')) {
        this.dashboardData = {
          ...JSON.parse(localStorage.getItem('dashboardData')),
          allocation: {
            allocation: 0,
            percentageFromLastYear: 0,
            utilization: 0,
          },
          dashboardLineItemBudgets: [],
          fundSources: [],
          totalApis: 0,
          totalTargets: 0,
        };
        await this.getDashboardData(cycle, campusId, deliveryUnitId)
        this.$refs.earning.setAllocation(this.dashboardData);
        this.$refs.profile.setData(
          this.dashboardData.totalApis,
          this.dashboardData.totalTargets,
          this.dashboardData.needBacApproval,
          this.dashboardData.needTechnicalReview,
          this.dashboardData.itemRequest
        );
        this.$refs.graphView.setData(this.dashboardData.dashboardLineItemBudgets);
        this.$refs.documenttracking.setCount(this.dashboardData.incomingTracks, this.dashboardData.incomingDepartmentTracks);
      }
    },
    getProcurementItemRequest(campusId) {
      this.$store
        .dispatch("dashboard/GetItemRequests", campusId)
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          this.$refs.profile.setPIR(res.data);
        })
        .catch((err) => {
          return this.showToast(
            "Something went wrong! - Getting Item Requests",
            "error"
          );
        });
    },
    getDashboardData(cycle, campusId, deliveryUnitId) {
      this.$store
        .dispatch("dashboard/GetTotalAllocation", { cycle, campusId, deliveryUnitId })
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          this.dashboardData.allocation = res.data.allocation;
          this.dashboardData.dashboardLineItemBudgets = res.data.dashboardLineItemBudgets;
          this.dashboardData.fundSources = res.data.fundSources;
          this.dashboardData.totalApis = res.data.totalApis;
          this.dashboardData.totalTargets = res.data.totalTargets;
        })
        .catch((err) => {
          return this.showToast("Something went wrong! - Getting Allocations", "error");
        });
    }
  },
};
</script>

<template>
  <Layout @changeDU="changeDU" @changeCycle="changeCycle" @changeCampus="changeCampus($event.id)">
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-xl-4">
        <Profile :userProfile="userProfile" ref="profile" :managePR="managePR" />
        <Earning ref="earning" />
        <DocumentTracking ref="documenttracking" />
      </div>
      <div class="col-xl-8">
        <div class="row" v-if="dashboardData && dashboardData.fundSources.length != 0">
          <div v-for="stat of dashboardData.fundSources" :key="stat.icon" class="col-md-4">
            <Stat :icon="'bx bx-purchase-tag-alt'" :title="stat.fundSourceName"
              :value="formatCurrency(stat.allocated)" />
          </div>
        </div>
        <Emailsent ref="graphView" />
        <template v-if="managePR">
          <ProcurementSummary ref="psRef" :fundSources="fundSources" :fsId="selectedFSId"
            @change-fs="getProcurementSummary($event, $store.state.data.cycle)" />
        </template>
      </div>
    </div>
  </Layout>
</template>